// Generated by Copilot- Start
import DtvTheme, { colorPalette } from "@directv-digital/dds.ui.dtv-theme";

/**
 * Centralized styles for ChlupInteractiveToolV2 and its child components
 * Organized by component for easy navigation
 */

// ============================================================================
// MAIN COMPONENT STYLES (ChlupInteractiveToolV2)
// ============================================================================
export const mainComponentStyles = {
  defaultSpacing: {
    marginLeft: "140px",
    marginRight: "140px",
    [DtvTheme.breakpoints.between(DtvTheme.breakpoints.values.sm, DtvTheme.breakpoints.values.md)]: {
      marginLeft: "32px",
      marginRight: "32px"
    },
    [DtvTheme.breakpoints.down(DtvTheme.breakpoints.values.sm)]: {
      marginLeft: "20px",
      marginRight: "20px",
      marginBottom: "20px"
    }
  },
  globalTextColor: {
    "& body": {
      color: colorPalette.neutral_white.main,
      "& *": {
        color: colorPalette.neutral_white.main
      }
    }
  },
  backdropBox: {
    height: {
      xs: "54px",
      sm: "73px",
      md: "85px"
    },
    width: "100%",
    position: "absolute",
    left: "0px",
    bottom: "0px",
    background: "linear-gradient(180deg, rgba(251, 251, 251, 0.00) 0%, rgba(251, 251, 251, 0.90) 70.67%)",
    backdropFilter: "blur(2px)"
  },
  heading: {
    color: colorPalette.neutral_white.main,
    textAlign: "center",
    fontSize: {
      xs: "24px !important",
      sm: "30px !important",
      md: "44px !important"
    },
    lineHeight: {
      xs: "28.8px",
      sm: "36px",
      md: "48.4px"
    },
    letterSpacing: {
      xs: "-0.48px",
      sm: "-0.6px",
      md: "-0.88px"
    },
    fontWeight: {
      xs: 400,
      sm: 500
    },
    fontFamily: "PFDinMed !important"
  },
  subheading: {
    color: colorPalette.neutral_white.main,
    textAlign: "center",
    fontSize: {
      xs: "20px",
      sm: "20px",
      md: "24px"
    },
    lineHeight: {
      xs: "26px",
      sm: "26px",
      md: "31.2px"
    },
    letterSpacing: {
      xs: "-0.48px",
      sm: "-0.6px",
      md: "-0.88px"
    },
    fontWeight: {
      xs: 400,
      sm: 400
    }
  },
  showMoreContainerUtility: {
    "& > div > ol > li": {
      cursor: "pointer",
      flexBasis: "auto",
      display: "inline-flex"
    },
    "::-webkit-scrollbar": { width: "4px" },
    "::-webkit-scrollbar-thumb": {
      backgroundColor: "darkgrey",
      borderRadius: "2px",
      height: "100px"
    }
  },
  showGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(180px, 1fr))",
    gap: "16px",
    justifyContent: "center",
    [DtvTheme.breakpoints.down(DtvTheme.breakpoints.values.sm)]: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: "20px"
    }
  },
  showItem: {
    textAlign: "center",
    margin: "0 auto",
    width: "100%"
  },
  showImage: {
    overflow: "hidden",
    margin: "0 auto",
    width: "200px"
  },
  cardMedia: {
    objectFit: "contain",
    width: "100%",
    maxWidth: "178px",
    borderRadius: "16px",
    border: "8px solid transparent",
    transition: "transform 0.3s ease-in-out, border-color 0.3s ease-in-out",
    margin: "10px auto",
    cursor: "pointer",
    "&:hover": {
      transform: "scale(1.1)",
      borderColor: "#1FBCF87A"
    }
  },
  showTitle: {
    color: colorPalette.neutral_white.main,
    wordWrap: "break-word",
    whiteSpace: "normal",
    textAlign: "left",
    marginLeft: "20px",
    fontSize: "14px !important"
  },
  channelsContainer: {
    position: "relative",
    display: "block",
    overflowY: "scroll",
    minHeight: {
      xs: "26px",
      sm: "26px",
      md: "26px"
    },
    transition: "height ease 0.3s, margin-top ease 0.3s"
  },
  channelIconsContainer: {
    padding: 0,
    margin: 0,
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "center",
    pl: "5px"
  }
};

// ============================================================================
// ICON BANNER STYLES (IconBannerV2)
// ============================================================================
export const iconBannerStyles = {
  tooltipStyles: {
    opacity: "1",
    transform: "none",
    transition: "opacity 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, transform 133ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    transformOrigin: "left center",
    backgroundColor: "rgba(97, 97, 97, 0.92)",
    borderRadius: "4px",
    color: colorPalette.white.main,
    padding: "4px 8px",
    fontSize: "14px",
    maxWidth: "230px",
    width: "max-content",
    display: "inline-block",
    whiteSpace: "normal",
    overflowWrap: "normal",
    wordBreak: "normal",
    margin: "0",
    fontWeight: 400,
    fontFamily: "roboto-regular",
    position: "relative"
  },
  zipCodeStyle: {
    padding: "10px 20px 0px 20px"
  }
};

// ============================================================================
// RSN CHANNEL MODAL STYLES (RsnChannelModalV2)
// ============================================================================
export const rsnChannelModalStyles = {
  modalPaper: {
    backgroundColor: "white",
    borderRadius: "8px",
    maxWidth: "600px",
    margin: "auto",
    position: "relative" as const
  },
  closeButton: {
    position: "absolute" as const,
    right: "8px",
    top: "8px",
    color: "#000000"
  },
  modalContent: {
    padding: "24px"
  },
  channelHeader: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
    marginBottom: "24px"
  },
  channelLogo: {
    width: "60px",
    height: "60px"
  },
  channelName: {
    color: "#000000",
    fontWeight: 600
  },
  packageSection: {
    marginTop: "24px"
  },
  packageTitle: {
    color: "#000000",
    fontWeight: 600,
    marginBottom: "16px"
  },
  legalText: {
    marginTop: "16px",
    fontSize: "12px",
    color: "#555555"
  }
};

// ============================================================================
// SVOD BANNER STYLES (SvodBannerV2)
// ============================================================================
export const svodBannerStyles = {
  svodContainer: {
    display: "flex",
    flexWrap: "wrap",
    gap: "16px",
    justifyContent: "center",
    padding: "20px 0"
  },
  svodTile: {
    cursor: "pointer",
    transition: "transform 0.2s ease-in-out",
    "&:hover": {
      transform: "scale(1.05)"
    }
  },
  svodIcon: {
    width: "80px",
    height: "80px",
    borderRadius: "8px"
  },
  svodName: {
    marginTop: "8px",
    textAlign: "center",
    color: colorPalette.neutral_white.main,
    fontSize: "14px"
  }
};

// ============================================================================
// LOCAL CHANNEL MODAL TABLE STYLES
// ============================================================================
const bps = DtvTheme.breakpoints;

export const localChannelTableStyles = {
  // Base Paper styles (common to all cells)
  basePaper: {
    elevation: 0,
    square: true
  },

  // Common cell properties
  commonCell: {
    textAlign: "center" as const,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },

  // Header cell styles
  headerCell: {
    backgroundColor: "#EAF1FA",
    color: "#102641",
    height: "56px"
  },

  // Header left cell (Affiliates)
  headerLeftCell: {
    border: `1px solid ${colorPalette.neutral[300]}`,
    borderLeft: "0px",
    borderBottom: "0px",
    borderTop: "0px"
  },

  // Header right cell (Channel No)
  headerRightCell: {
    border: `1px solid ${colorPalette.neutral[300]}`,
    borderLeft: "0px",
    borderRight: "0px",
    borderBottom: "0px",
    borderTop: "0px"
  },

  // Body cell styles
  bodyCell: {
    backgroundColor: "#F4F4F4",
    color: "#102641",
    minHeight: "84px",
    height: "100%",
    padding: "20px"
  },

  // Body left cell
  bodyLeftCell: {
    border: `1px solid ${colorPalette.neutral[300]}`,
    borderLeft: "0px",
    borderRight: `1px solid ${colorPalette.neutral[300]}`,
    borderBottom: "0px",
    borderTop: "0px"
  },

  // Body right cell
  bodyRightCell: {
    border: "1px solid #999999",
    borderRight: "0px",
    borderBottom: "0px",
    borderTop: "0px"
  },

  // Text styles
  headerText: {
    fontSize: "16px !important",
    paddingTop: "17px",
    [bps.between(bps.values.sm, bps.values.lg)]: {
      paddingTop: "15px"
    },
    [bps.down(bps.values.sm)]: {
      paddingTop: "16px"
    }
  },

  bodyText: {
    fontSize: "16px !important"
  }
};

// ============================================================================
// UTILITY: Combine all styles for easy import
// ============================================================================
export const combinedStyles = {
  main: mainComponentStyles,
  iconBanner: iconBannerStyles,
  rsnModal: rsnChannelModalStyles,
  svodBanner: svodBannerStyles,
  localTable: localChannelTableStyles
};

// ============================================================================
// SHARED DTV MODAL STYLES
// Applied consistently across all V2 channel/SVOD/movie modals.
//
//  dtvModalStyle      — outer modal container (max-width cap at md+)
//  dtvModalBodyStyle  — scrollable body with responsive margin + max-height
//  dtvModalCloseStyle — close icon/button sizing; used only on RSN + Local modals
// ============================================================================
// Generated by Copilot- Start - 2026-03-26 19:49:59

/**
 * sx prop passed directly to <DtvModal> so it flows through to the MUI <Modal> root.
 * This sets the stacking context above ComparePackageTray (zIndex 1302).
 */
export const dtvModalRootSx = { zIndex: 1303 };

export const dtvModalStyle = {
  maxHeight: "min-content",
  width: "100%",
  [DtvTheme.breakpoints.up(DtvTheme.breakpoints.values.md)]: {
    maxWidth: "600px !important"
  }
};

export const dtvModalBodyStyle = {
  height: "min-content",
  maxHeight: {
    xs: "90vh",
    sm: "80vh"
  },
  margin: {
    xs: "0px 20px 20px 20px !important",
    sm: "0px 32px 24px 32px !important",
    md: "0px 48px 24px 48px !important"
  }
};

export const dtvModalCloseStyle = {
  closeIconStyle: {
    width: {
      xs: "24px",
      sm: "32px",
      md: "32px"
    },
    height: {
      xs: "24px",
      sm: "32px",
      md: "32px"
    }
  },
  closeButtonStyle: {
    marginTop: "12px",
    marginBottom: {
      xs: "0px",
      sm: "0px",
      md: "0px"
    },
    marginRight: "12px"
  }
};
// Generated by Copilot- End - 2026-03-26 19:49:59
// Generated by Copilot- End
